const DEFAULT_CONFIG = {
    brandName: "ReachForge Leads",
    version: "current",
    supportEmail: "support@reachforge.io",
};

export function getSiteConfig() {
    if (typeof window === "undefined") {
        return DEFAULT_CONFIG;
    }
    return {
        ...DEFAULT_CONFIG,
        ...(window.__REACHFORGE_SITE_CONFIG__ || {}),
    };
}
